module.exports = __webpack_public_path__ + "media/images/pages/solutions/services/reporting-67e2279abdd10f0111e1b5988099ffb6.svg";